/**
 * This component helps to lazy-load components
 */
import React from 'react'
import { useEntry } from 'intersection-observer'
import { useDevice } from 'device'
import Bone from '../Bone/Bone'
import WidthContainer from '../WidthContainer/WidthContainer'


type IntersectionVisibleProps = {
  className?: string
  children: React.ReactNode
  fallback?: React.ReactNode
  observerProps?: IntersectionObserverInit
}


const IntersectionVisible: React.CFC<IntersectionVisibleProps> = (props) => {
  const { className, children, fallback = defaultFallback, observerProps = { rootMargin: '50%' } } = props
  const { isBot } = useDevice()
  const [ containerRef, entry ] = useEntry({ once: true, observerProps })

  const isVisible = isBot || entry?.isIntersecting

  return (
    <div ref={containerRef} className={className}>
      {
        isVisible ? children : fallback
      }
    </div>
  )
}

export const createFallback = (options: { h: number, widthContainer?: boolean }) => {
  const bone = <Bone pw={100} h={options.h} />
  if (options.widthContainer) {
    return <WidthContainer>{bone}</WidthContainer>
  }

  return bone
}

export const defaultFallback = createFallback({ h: 200, widthContainer: false })
export const widthContainerFallback = createFallback({ h: 200, widthContainer: true })


export default IntersectionVisible
